import { createContext, useContext, useEffect, useState } from 'react'
import { useSessione } from './SessioneProvider'
import { useLocation } from "react-router-dom"
import { useAppContext } from 'GlobalContext'

const CHIAVE_VERBALE = 'chiaveVerbale'
const CHIAVE_VERBALE_PAGAMENTO = 'chiaveVerbalePagamento'
const VerbaliContext = createContext()

function VerbaliProvider(props) {
  const { children } = props

  const {
    [CHIAVE_VERBALE]: chiaveVerbale,
    [CHIAVE_VERBALE_PAGAMENTO]: chiaveVerbalePagamento,
    salvaInSessione,
    rimuoviDaSessione,
  } = useSessione()


  const [verbale, salvaVerbale] = useState(null)
  const [listaVerbali, setListaVerbali] = useState(null)


  function salvaChiaveVerbale(chiaveVerbale) {
    salvaInSessione(CHIAVE_VERBALE, chiaveVerbale)
  }

  function pulisciChiaveVerbale() {
    rimuoviDaSessione(CHIAVE_VERBALE)
  } 

  function salvaChiaveVerbalePagamento(chiaveVerbale) {
    salvaInSessione(CHIAVE_VERBALE_PAGAMENTO, chiaveVerbale)
  }

  function pulisciChiaveVerbalePagamento() {
    rimuoviDaSessione(CHIAVE_VERBALE_PAGAMENTO)
  } 
  
  const { pathname: pathCorrente } = useLocation()
  
  
  /* gestione modulo richiesta preavviso */
  const [showPreavviso, setShowPreavviso] = useState(false)
  useEffect(() => {
    setShowPreavviso( ['/frontoffice/verbale/listaVerbali'].includes(pathCorrente))
  }, [pathCorrente])
  /* -- */
  

  const verbaliContextValue = {
    showPreavviso,
    isModalitaWeb : Boolean(chiaveVerbale),
    verbale,
    chiaveVerbale,
    chiaveVerbalePagamento,
    listaVerbali,
    salvaVerbale,
    salvaChiaveVerbale,
    pulisciChiaveVerbale,
    salvaChiaveVerbalePagamento,
    pulisciChiaveVerbalePagamento,
    setListaVerbali
  }

  return (
    <VerbaliContext.Provider value={verbaliContextValue}>
      {children}
    </VerbaliContext.Provider>
  )
}

function useVerbaliContext() {
  return useContext(VerbaliContext)
}

// eslint-disable-next-line react-refresh/only-export-components
export { VerbaliProvider, useVerbaliContext, CHIAVE_VERBALE }
